import React, { useMemo } from 'react'

import { connect } from 'react-redux'
import { getUser } from '../../reducers/UserReducer'
import { getTranslate } from 'react-localize-redux'
import OrderBySelector from './OrderBySelector'
import {
  INSTITUTION_CONTEXT, SCHOOL_CONTEXT, ORDER_BY_CREATED_AT, ORDER_BY_INSTITUTION,
  ORDER_BY_SCHOOL, ORDER_BY_SECTION, ORDER_BY_SECTOR, ORDER_BY_START_DATE,
  ORDER_BY_STUDENT
} from '../../utils/constants'

const DEFAULT_OPTIONS = [
  { key: 'creation-date', value: ORDER_BY_CREATED_AT, text: 'Creation date' },
  { key: 'start-date', value: ORDER_BY_START_DATE, text: 'Start date' },
  { key: 'student', value: ORDER_BY_STUDENT, text: 'Students' },
  { key: 'section', value: ORDER_BY_SECTION, text: 'Sections' },
  { key: 'sector', value: ORDER_BY_SECTOR, text: 'Care units' }
]
const INSTITUTION_ADDITIONAL_OPTION = {
  key: 'school', value: ORDER_BY_SCHOOL, text: 'Schools'
}
const SCHOOL_ADDITIONAL_OPTION = {
  key: 'institution', value: ORDER_BY_INSTITUTION, text: 'Institutions'
}

const mapStateToProps = state => {
  return {
    t: getTranslate(state.locale),
    user: getUser(state.getUser)
  }
}

const InternshipStatesOrderBy = ({ direction, user, value, onChange, onDirectionChange, t }) => {
  const additionalOption = useMemo(() => {
    let option = null

    if (user.context === SCHOOL_CONTEXT) {
      option = SCHOOL_ADDITIONAL_OPTION
    } else if (user.context === INSTITUTION_CONTEXT) {
      option = INSTITUTION_ADDITIONAL_OPTION
    }

    return option
  }, [user.context])
  const options = useMemo(() => {
    const options = DEFAULT_OPTIONS.map(option => {
      return { ...option, text: t(option.text) }
    })

    if (additionalOption !== null) {
      options.push({ ...additionalOption, text: translate(additionalOption.text) })
    }

    return options
  }, [additionalOption, t])

  return (
    <OrderBySelector
      direction={direction}
      options={options}
      value={value ?? ORDER_BY_CREATED_AT}
      onChange={onChange}
      onDirectionChange={onDirectionChange}
    />
  )
}

export default connect(mapStateToProps)(InternshipStatesOrderBy)
